import { render, staticRenderFns } from "./expertEnter.vue?vue&type=template&id=64615e5a&scoped=true"
import script from "./expertEnter.vue?vue&type=script&lang=js"
export * from "./expertEnter.vue?vue&type=script&lang=js"
import style0 from "./expertEnter.vue?vue&type=style&index=0&id=64615e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64615e5a",
  null
  
)

export default component.exports